"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFreeCropParameter = exports.CollectionModelFreeCropParameterMutator = void 0;
var tslib_1 = require("tslib");
var cropParameter_1 = require("./cropParameter");
var CollectionModelFreeCropParameterMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFreeCropParameterMutator, _super);
    function CollectionModelFreeCropParameterMutator(cropParameter) {
        return _super.call(this, cropParameter) || this;
    }
    CollectionModelFreeCropParameterMutator.prototype.init = function (x, y, width, height) {
        this.cropParameter.cropParameterState.Mutator.create('free');
        this.setCrop(x, y, width, height);
    };
    CollectionModelFreeCropParameterMutator.prototype.setCrop = function (x, y, width, height) {
        var state = this.getValue();
        state.x = x;
        state.y = y;
        state.width = width;
        state.height = height;
        this.setValue(state);
    };
    return CollectionModelFreeCropParameterMutator;
}(cropParameter_1.CollectionModelCropParameterMutator));
exports.CollectionModelFreeCropParameterMutator = CollectionModelFreeCropParameterMutator;
var CollectionModelFreeCropParameter = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFreeCropParameter, _super);
    function CollectionModelFreeCropParameter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = CollectionModelFreeCropParameter.TAG;
        _this.Mutator = new CollectionModelFreeCropParameterMutator(_this);
        return _this;
    }
    CollectionModelFreeCropParameter.state = function (id) {
        return {
            id: id,
            tag: 'free',
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    CollectionModelFreeCropParameter.isFree = function (t) {
        return t.tag === CollectionModelFreeCropParameter.TAG;
    };
    Object.defineProperty(CollectionModelFreeCropParameter.prototype, "x", {
        get: function () {
            var state = this.state;
            return state.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFreeCropParameter.prototype, "y", {
        get: function () {
            var state = this.state;
            return state.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFreeCropParameter.prototype, "width", {
        get: function () {
            var state = this.state;
            return state.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFreeCropParameter.prototype, "height", {
        get: function () {
            var state = this.state;
            return state.height;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFreeCropParameter.TAG = 'free';
    return CollectionModelFreeCropParameter;
}(cropParameter_1.CollectionModelCropParameter));
exports.CollectionModelFreeCropParameter = CollectionModelFreeCropParameter;
//# sourceMappingURL=free.cropParameter.js.map